// extracted by mini-css-extract-plugin
export default {"title":"TitleComp2_title__ysPjY","show":"TitleComp2_show__PxrbI","fadeIn":"TitleComp2_fadeIn__zvSHT"};